import { ListItem, ListItemWithPageData } from './product-page.service';
import { TRAINING_ROOT } from '../constants';
import { ActivatableItemSummary, ListActivatableItemsResponse } from '@vendasta/marketplace-apps';
import { LmiCategory } from '@galaxy/marketplace-apps';

export function sortAppListItems(appListItems: ListItem[]): ListItem[] {
  return appListItems.sort((a1, a2) => {
    return a1.name.toLowerCase().localeCompare(a2.name.toLowerCase());
  });
}
export function convertActivatableItemSummariesToAppListItems(activatableItems: ActivatableItemSummary[]): ListItem[] {
  if (!activatableItems || activatableItems.length === 0) {
    return [];
  }

  return activatableItems.map((activatableItem) => {
    return activatableItemToListItem(activatableItem);
  });
}
export function activatableItemToListItem(activatableItem: ActivatableItemSummary): ListItem {
  return {
    itemId: activatableItem.itemId,
    name: activatableItem.sellerWhitelabelName ?? activatableItem.defaultName,
    iconUrl: activatableItem.sellerWhitelabelIconUrl ?? activatableItem.iconUrl,
    learnMoreUrl: `/${TRAINING_ROOT}/product/${activatableItem.itemId}`,
    type: activatableItem.itemType,
    requiredItems: activatableItem.requiredItems,
    deliveryMethod: activatableItem.deliveryMethod,
  } as ListItem;
}
export function convertListActivatableItemResponse(
  listActivatableItemsResponse: ListActivatableItemsResponse,
): ListItemWithPageData {
  if (!listActivatableItemsResponse) {
    return {} as ListItemWithPageData;
  }

  const listItems = convertActivatableItemSummariesToAppListItems(
    listActivatableItemsResponse.activatableItemSummaries,
  );

  return {
    items: listItems,
    nextCursor: listActivatableItemsResponse.nextCursor,
    hasMore: listActivatableItemsResponse.hasMore,
    totalResults: listActivatableItemsResponse.totalResults,
  } as ListItemWithPageData;
}
export function convertSDKLmiEnumToDisplayStrings(lmiCats: LmiCategory[]): string[] {
  const sdkLmiEnumToStringMap = new Map<LmiCategory, string>([
    [LmiCategory.LMI_CATEGORY_ADVERTISING, 'Advertising'],
    [LmiCategory.LMI_CATEGORY_CONTENT_AND_EXPERIENCE, 'Content and Experience'],
    [LmiCategory.LMI_CATEGORY_LISTINGS, 'Listings'],
    [LmiCategory.LMI_CATEGORY_REPUTATION, 'Reputation'],
    [LmiCategory.LMI_CATEGORY_SEO, 'SEO'],
    [LmiCategory.LMI_CATEGORY_SOCIAL, 'Social'],
    [LmiCategory.LMI_CATEGORY_WEBSITE, 'Website'],
  ]);

  return (lmiCats || []).map((lmiCat) => sdkLmiEnumToStringMap.get(lmiCat));
}
